import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarConsumoLayer from "../components/CadastrarConsumoLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarConsumoPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("consumo.breadcrumb.create")} />
      <CadastrarConsumoLayer />
    </MasterLayout>
  );
};

export default CadastrarConsumoPage;
